import { render, staticRenderFns } from "./toc-accordion.vue?vue&type=template&id=639ff60a"
import script from "./toc-accordion.vue?vue&type=script&lang=js"
export * from "./toc-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default})
